import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import { PageHeader, CtaButton } from "@/components/Bits";
import { MUNITION } from "@/data/catalog";

const CAT_IMG =
  "https://images.unsplash.com/photo-1551485913-b5dbedb723bb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export default function Munition() {
  return (
    <>
      <Seo
        title="Munition"
        description="Marken-Munition ab Lager in jedem gängigen Kaliber — vom Kleinkaliber bis zur Großwildpatrone. Für Sport, Jagd und Behörde bei IMPEXMILTRADE GMBH."
      />
      <PageHeader
        code="SEK-02 / Sport · Jagd · Behörde"
        title="Munition"
        sub="Qualitätsmunition führender Hersteller in allen gängigen Kalibern. Ob Trainingsmunition für den Schießstand oder präzise Jagdpatronen — wir liefern ab Lager und beraten zur passenden Laborierung."
      />

      <section className="relative border-b border-border">
        <div className="relative h-64 overflow-hidden md:h-80">
          <img src={CAT_IMG} alt="Munition im Magazin" className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-background/40" aria-hidden />
          <div className="blueprint-grid absolute inset-0 opacity-30" aria-hidden />
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 py-16" data-testid="munition-list">
        <div className="mb-8 flex items-center justify-between border-b border-border pb-4">
          <p className="mono-label text-primary">Kaliber · Übersicht</p>
          <p className="mono-label text-muted-foreground">{MUNITION.length} Kaliber</p>
        </div>

        <div className="border-l border-t border-border">
          {MUNITION.map((m, i) => (
            <motion.div
              key={m.code}
              initial={{ opacity: 0, x: -12 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.04 }}
              className="grid grid-cols-1 border-b border-r border-border transition-colors hover:bg-card sm:grid-cols-[120px_1fr_160px_140px]"
              data-testid={`munition-${m.code}`}
            >
              <span className="mono-label border-r border-border p-4 text-primary">{m.code}</span>
              <span className="p-4 font-display text-xl font-500 uppercase tracking-tight sm:border-r sm:border-border">{m.name}</span>
              <span className="p-4 font-body text-sm text-muted-foreground sm:border-r sm:border-border">{m.use}</span>
              <span className="p-4 font-mono-t text-sm text-foreground">{m.weight}</span>
            </motion.div>
          ))}
        </div>

        <div className="mt-12 border border-border p-8 text-center">
          <p className="font-body text-muted-foreground">
            Größere Mengen oder Spezialkaliber für Verein oder Behörde? Fragen Sie unser Lager an.
          </p>
          <div className="mt-6 flex justify-center">
            <CtaButton to="/kontakt" testid="munition-cta">
              Kaliber anfragen <ArrowRight size={16} />
            </CtaButton>
          </div>
        </div>
      </section>
    </>
  );
}
